module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Fc-Gb-Ha-Ia.827fe04c.png";